import {
  TURNSTILE_VERIFY_RATE_LIMITED_ERROR_CODE,
  TURNSTILE_VERIFY_RATE_LIMITED_RETRY_MS,
} from "../constants/turnstile";

const getErrorCode = (value: unknown): unknown => {
  const { error, data } = (value ?? {}) as { error?: { code?: unknown } | null; data?: { code?: unknown } | null };
  return error?.code ?? data?.code;
};

export const isVerifyRateLimited = (value: unknown): boolean =>
  getErrorCode(value) === TURNSTILE_VERIFY_RATE_LIMITED_ERROR_CODE;

export const createRateLimitedBackoff = () => {
  let untilMs = 0;

  return {
    start: (): void => {
      untilMs = Date.now() + TURNSTILE_VERIFY_RATE_LIMITED_RETRY_MS;
    },
    clear: (): void => {
      untilMs = 0;
    },
    isActive: (): boolean => Date.now() < untilMs,
    remainingMs: (): number => Math.max(untilMs - Date.now(), 0),
  };
};

interface VerifiedCredentials {
  sessionToken?: string | null;
  deviceToken?: string | null;
}

interface VerifyOutcomeHandlers {
  onRateLimited: () => void;
  onOutcome: (data: VerifiedCredentials | null) => void;
  onFailure: () => void;
}

export const handleVerifyResult = (
  result: { data?: VerifiedCredentials | null },
  handlers: VerifyOutcomeHandlers
): void => {
  if (isVerifyRateLimited(result)) {
    handlers.onRateLimited();
    return;
  }
  handlers.onOutcome(result.data ?? null);
};

export const handleVerifyError = (error: unknown, handlers: VerifyOutcomeHandlers): void => {
  if (isVerifyRateLimited(error)) {
    handlers.onRateLimited();
    return;
  }
  handlers.onFailure();
};
